import { BaseWebComponentDataProvider } from '../../../../../framework/BaseWebComponentDataProvider';
import { RuleSetItem } from '../types';

export abstract class IntegrityMonitorPolicyRuleSetsSectionBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getCompanyRuleSetsForPolicy(): Promise<Array<RuleSetItem>>;
  public abstract getRuleSetsForPolicy(ruleSetIds: Array<string>): Promise<Array<RuleSetItem>>;
}
